var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoreUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 12.5821C9.73858 12.5821 7.5 10.3435 7.5 7.58212C7.5 4.8207 9.73858 2.58212 12.5 2.58212C15.2614 2.58212 17.5 4.8207 17.5 7.58212C17.5 10.3435 15.2614 12.5821 12.5 12.5821ZM12.5 10.5821C14.1569 10.5821 15.5 9.23898 15.5 7.58212C15.5 5.92527 14.1569 4.58212 12.5 4.58212C10.8431 4.58212 9.5 5.92527 9.5 7.58212C9.5 9.23898 10.8431 10.5821 12.5 10.5821Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 17.9155V22.5821H2.5V17.9155C2.5 16.0939 4.09027 14.5821 5.95455 14.5821H19.0455C20.9097 14.5821 22.5 16.0939 22.5 17.9155V22.5821H20.5V17.9155C20.5 17.2217 19.8272 16.5821 19.0455 16.5821H5.95455C5.17282 16.5821 4.5 17.2217 4.5 17.9155Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreUser);
export default __webpack_public_path__ + "static/media/storeUser.7527e8e01486487faca4bd843a7fb217.svg";
export { ForwardRef as ReactComponent };